import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import {
  BackendService,
  InsuranceService,
  DataHelperService,
  formReducer
} from './../shared/index';

import { DisplayQuoteComponent } from './display-quote.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    StoreModule.provideStore({ cvform: formReducer }),
    StoreDevtoolsModule.instrumentOnlyWithExtension()
  ],
  declarations: [DisplayQuoteComponent],
  providers: [
    BackendService,
    InsuranceService,
    DataHelperService
  ],
  bootstrap: [DisplayQuoteComponent]
})
export class DisplayQuoteModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/display-quote/display-quote.module.ts